import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { api } from "../lib/api.ts";
import { useT } from "../lib/i18n.ts";
import { feedback } from "../components/Feedback.tsx";
import { Ic } from "../components/Icons.tsx";

function NavRow({ to, label, meta }: { to: string; label: string; meta?: string | undefined }) {
  return (
    <Link className="nav-row" to={to}>
      <span className="grow">{label}</span>
      {meta && <span className="meta">{meta}</span>}
      <span style={{ color: "var(--ink-3)", display: "inline-flex" }}>{Ic.chevron({ size: 16 })}</span>
    </Link>
  );
}

/** Settings hub (round 5): one row per page, all alike — nothing to scroll past.
    Appearance · Shelf · Connected services · Feedback · Account (Rest merged into Shelf, D-34). */
export function SettingsScreen() {
  const t = useT();
  const { data: ai } = useQuery({ queryKey: ["ai"], queryFn: api.ai.status });
  return (
    <div>
      <h1 className="display" style={{ marginBottom: "var(--sp-4)" }}>{t("settings.title")}</h1>
      <NavRow to="/settings/appearance" label={t("settings.appearance")} />
      <NavRow to="/settings/shelf" label={t("settings.shelf")} meta={t("settings.shelfMeta")} />
      <NavRow to="/settings/services" label={t("settings.services")} meta={ai?.connected ? t("connect.connected") : t("settings.servicesMeta")} />
      <button className="nav-row" onClick={feedback.open}>
        <span className="grow">{t("settings.feedback")}</span>
        <span style={{ color: "var(--ink-3)", display: "inline-flex" }}>{Ic.chevron({ size: 16 })}</span>
      </button>
      <NavRow to="/settings/account" label={t("settings.account")} meta={t("settings.accountMeta")} />
    </div>
  );
}
